import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";
import {
  BulkAction,
  createBulkRemoveFromChannelAction,
  DataService,
  DeleteProductDocument,
  DeletionResult,
  DuplicateEntityDialogComponent,
  GetProductListQuery,
  isMultiChannel,
  ItemOf,
  ModalService,
  NotificationService,
  Permission,
  PermissionsService,
} from "@bb-vendure/admin-ui/core";
import { unique } from "@vendure/common/lib/unique";
import { EMPTY } from "rxjs";
import { map, switchMap, take } from "rxjs/operators";
import { RequestDeleteProductsDocument } from "src/generated-gql/graphql";

import {
  AssignProductsToChannelDialogComponent,
  BulkAddFacetValuesDialogComponent,
} from "@bb-vendure/admin-ui/catalog";
import { ProductListComponent } from "./product-list.component";

export const deleteProductsBulkAction: BulkAction<
  ItemOf<GetProductListQuery, "products">,
  ProductListComponent
> = {
  location: "product-list",
  label: _("common.delete"),
  icon: "trash",
  iconClass: "is-danger",
  requiresPermission: (userPermissions) =>
    userPermissions.includes(Permission.DeleteProduct) ||
    userPermissions.includes(Permission.DeleteCatalog),
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);
    const permissionsService = injector.get(PermissionsService);
    modalService
      .dialog({
        title: _("catalog.confirm-bulk-request-delete-products"),
        translationVars: {
          count: selection.length,
        },
        buttons: [
          { type: "secondary", label: _("common.cancel") },
          { type: "danger", label: _("common.delete"), returnValue: true },
        ],
      })
      .pipe(take(1))
      .subscribe((response) => {
        if (response) {
          const perm = permissionsService.userHasPermissions(["DeleteProduct"]);
          if (perm) {
            dataService.product.deleteProducts(unique(selection.map(p => p.id))).subscribe(({deleteProducts}) =>{
              notificationService.success(_('catalog.notify-bulk-delete-products-success'), {
                count: deleteProducts.length,
            });
              hostComponent.refresh();
              clearSelection();
            })
          } else
          dataService
            .mutate(RequestDeleteProductsDocument, {
              ids: unique(selection.map((p) => p.id)),
            })

            .subscribe((result) => {
              if (result.requestDeleteProducts) {
                notificationService.success(
                  _("catalog.notify-bulk-request-delete-products-success"),
                  {
                    count: result.requestDeleteProducts,
                  }
                );
              }
              hostComponent.refresh();
              clearSelection();
            });
        }
      });
  },
};
